import React, { useMemo } from 'react';
import { IconPlug } from '../../../../../../../components/icons-group';
import { IconArrowLink } from '../../../../../../../components/icons/icon-arrow-link';
import { MeasurementItemCommon } from '../../../../../../../components/measurement-item/measurement-item';
import { WRONG_MEASUREMENT_VALUE } from '../../../../../../../const';
import {
  VectorParameterTypeInternal,
  ScalarParameterTypeInternal,
  MeasurementChannelKind,
  OptimizerVectorParameterTypeInternal,
  OptimizerScalarParameterTypeInternal,
} from '../../../../../../../data-access/gql-types/graphql';
import { ROUTES } from '../../../../../../../routes/routes';
import { measurementNameParse } from '../../../meter/utils';

type MeasurementParameters = {
  shortcut?: string;
  unit: string;
  symbol: string;
  fixed: number;
};

export enum MeasurementGroup {
  SinglePhase = 'SinglePhase',
  Absolute = 'Absolute',
}

type MeasurementItemProps = {
  channelId: string;
  measurement:
    | VectorParameterTypeInternal
    | ScalarParameterTypeInternal
    | OptimizerVectorParameterTypeInternal
    | OptimizerScalarParameterTypeInternal;
  measurementGroup: MeasurementGroup;
  text: string;
  value: number;
  parameters: MeasurementParameters;
  kind: MeasurementChannelKind;
  phase?: number;
  subText?: string;
  subValue?: string;
};

export const MeasurementItem: React.FC<MeasurementItemProps> = ({
  channelId,
  measurement,
  measurementGroup,
  text,
  value,
  parameters,
  kind,
  phase,
  subText,
  subValue,
}) => {
  const iconValue = useMemo(() => {
    if (measurement === OptimizerVectorParameterTypeInternal.RelayState) return 'R';
    return parameters.shortcut ?? parameters.symbol ? parameters.symbol : parameters.unit;
  }, [parameters]);

  const iconFontSize = useMemo(() => {
    switch (iconValue.length) {
      case 1:
      case 2:
        return 20;
      case 3:
        return 16;
      case 4:
        return 14;
      default:
        return 12;
    }
  }, [iconValue]);

  const relayState = useMemo(() => {
    if (measurement === OptimizerVectorParameterTypeInternal.RelayState) return <IconPlug isOn={!!value} />;
    return null;
  }, [value]);

  const formatedValue = value.toFixed(parameters.fixed);

  return (
    <>
      {value !== WRONG_MEASUREMENT_VALUE ? (
        <MeasurementItemCommon
          text={measurementNameParse(text)}
          subText={subText}
          iconFontSize={iconFontSize}
          symbolIcon={iconValue}
          subValue={subValue}
          value={
            measurement !== OptimizerVectorParameterTypeInternal.RelayState
              ? `${formatedValue} ${parameters.unit}`
              : relayState
          }
          redirectPathname={ROUTES.MeasurementDetails(
            channelId,
            measurementGroup,
            measurement,
            kind,
            phase ? `${phase}` : '',
          )}
          {...(kind === MeasurementChannelKind.Optimizer &&
            parseFloat(formatedValue) !== 0 &&
            (measurement === OptimizerVectorParameterTypeInternal.Current ||
              measurement === OptimizerVectorParameterTypeInternal.ActivePower) && {
              valueIcon: <IconArrowLink size={22} direction={value < 0 ? 'up' : 'down'} />,
            })}
        />
      ) : null}
    </>
  );
};
